import React from 'react';
import CategoryTable from '../../components/admin/category-table/CategoryTable';

const CategoryAdmin = () => {
  return <CategoryTable />;
};

export default CategoryAdmin;
